import React, { useState } from 'react';
import './Portfolio.css';
import { FaChevronUp } from 'react-icons/fa'; // from FontAwesome


const Portfolio = () => {

    const [showP, setShowP] = useState(true)

    const pDekhao = () => setShowP(false)
    const pMatDekhao = () => setShowP(true)


    return (

        <div id="portfolio" className="portfolio">
            <h1 className="heading">Portfolio</h1>
            <p className="subheading">
                {/* We provide personalized, end-to-end software services to drive your business success */}
            </p>
            <div className="portfolio-grid">


                <div id='uthoKaAbba' onMouseEnter={pDekhao} onMouseLeave={pMatDekhao}>
                    <img src='/Assets/Portfolio/Emotional-Wellness-AI-Coach.png' alt='generativeai' style={{ width: '100%', height: '100%' }} />
                    <div id='Utho' style={{ width: '100%', backgroundColor: 'rgba(0,0,0, 0.9)', color: 'white', position: 'absolute', bottom: '0', textAlign: 'center', overflow: 'hidden' }}>
                        <h2 style={{ marginTop: '20px', marginBottom: '20px' }}><FaChevronUp /></h2>
                        <p hidden={showP} style={{ textAlign: 'justify', paddingInline: '30px 30px' }}>AI-driven Emotional Wellness Coach / therapist offering deep emotional insight analysis and clinically-aligned, real-time mental health evaluations.</p>
                    </div>
                </div>

                <div id='uthoKaAbba' onMouseEnter={pDekhao} onMouseLeave={pMatDekhao}>
                    <img src='/Assets/Portfolio/Integrated-Trade-Finance-Suite.png' alt='generativeai' style={{ width: '100%', height: '100%' }} />
                    <div id='Utho' style={{ width: '100%', backgroundColor: 'rgba(0,0,0, 0.9)', color: 'white', position: 'absolute', bottom: '0', textAlign: 'center', overflow: 'hidden' }}>
                        <h2 style={{ marginTop: '20px', marginBottom: '20px' }}><FaChevronUp /></h2>
                        <p hidden={showP} style={{ textAlign: 'justify', paddingInline: '30px 30px' }}>Integrated Trade Finance Suite optimizing budgets, spend tracking, and finance; empowering seamless distributor claim automation.</p>
                    </div>
                </div>

                <div id='uthoKaAbba' onMouseEnter={pDekhao} onMouseLeave={pMatDekhao}>
                    <img src='/Assets/Portfolio/Sales-Operations-&-Channel-Management.png' alt='generativeai' style={{ width: '100%', height: '100%' }} />
                    <div id='Utho' style={{ width: '100%', backgroundColor: 'rgba(0,0,0, 0.9)', color: 'white', position: 'absolute', bottom: '0', textAlign: 'center', overflow: 'hidden' }}>
                        <h2 style={{ marginTop: '20px', marginBottom: '20px' }}><FaChevronUp /></h2>
                        <p hidden={showP} style={{ textAlign: 'justify', paddingInline: '30px 30px' }}>Sales Operations & Channel Management platform enabling live order processing, forecasting, tracking, and distributor network control.</p>
                    </div>
                </div>

                <div id='uthoKaAbba' onMouseEnter={pDekhao} onMouseLeave={pMatDekhao}>
                    <img src='/Assets/Portfolio/Computer-Vision-for-Public-Safety.png' alt='generativeai' style={{ width: '100%', height: '100%' }} />
                    <div id='Utho' style={{ width: '100%', backgroundColor: 'rgba(0,0,0, 0.9)', color: 'white', position: 'absolute', bottom: '0', textAlign: 'center', overflow: 'hidden' }}>
                        <h2 style={{ marginTop: '20px', marginBottom: '20px' }}><FaChevronUp /></h2>
                        <p hidden={showP} style={{ textAlign: 'justify', paddingInline: '30px 30px' }}>Surveillance-based AI platform for proactive crime detection and pattern prediction using advanced computer vision.</p>
                    </div>
                </div>

                <div id='uthoKaAbba' onMouseEnter={pDekhao} onMouseLeave={pMatDekhao}>
                    <img src='/Assets/Portfolio/Smart-Pharma-Outreach-Solution.png' alt='generativeai' style={{ width: '100%', height: '100%' }} />
                    <div id='Utho' style={{ width: '100%', backgroundColor: 'rgba(0,0,0, 0.9)', color: 'white', position: 'absolute', bottom: '0', textAlign: 'center', overflow: 'hidden' }}>
                        <h2 style={{ marginTop: '20px', marginBottom: '20px' }}><FaChevronUp /></h2>
                        <p hidden={showP} style={{ textAlign: 'justify', paddingInline: '30px 30px' }}>Smart management suite for pharmaceutical outreach teams with territory control and live activity insights.</p>
                    </div>
                </div>

                <div id='uthoKaAbba' onMouseEnter={pDekhao} onMouseLeave={pMatDekhao}>
                    <img src='/Assets/Portfolio/Smart-EHR-with-Accurate-Diagnostic-Coding.png' alt='generativeai' style={{ width: '100%', height: '100%' }} />
                    <div id='Utho' style={{ width: '100%', backgroundColor: 'rgba(0,0,0, 0.9)', color: 'white', position: 'absolute', bottom: '0', textAlign: 'center', overflow: 'hidden' }}>
                        <h2 style={{ marginTop: '20px', marginBottom: '20px' }}><FaChevronUp /></h2>
                        <p hidden={showP} style={{ textAlign: 'justify', paddingInline: '30px 30px' }}>Digitized EHR platform featuring full ICD-10 support for accurate diagnosis recording and paperless patient care.</p>
                    </div>
                </div>
                
                <div id='uthoKaAbba' onMouseEnter={pDekhao} onMouseLeave={pMatDekhao}>
                    <img src='/Assets/Portfolio/Telecom-Solutions-for-Emerging-Markets.png' alt='generativeai' style={{ width: '100%', height: '100%' }} />
                    <div id='Utho' style={{ width: '100%', backgroundColor: 'rgba(0,0,0, 0.9)', color: 'white', position: 'absolute', bottom: '0', textAlign: 'center', overflow: 'hidden' }}>
                        <h2 style={{ marginTop: '20px', marginBottom: '20px' }}><FaChevronUp /></h2>
                        <p hidden={showP} style={{ textAlign: 'justify', paddingInline: '30px 30px' }}>Telecom Innovation Suite launched across African markets through strategic collaboration with global vendors and cross-functional teams.</p>
                    </div>
                </div>
            
                <div id='uthoKaAbba' onMouseEnter={pDekhao} onMouseLeave={pMatDekhao}>
                    <img src='/Assets/Portfolio/EDA-Automation-for-Chip-Design.png' alt='generativeai' style={{ width: '100%', height: '100%' }} />
                    <div id='Utho' style={{ width: '100%', backgroundColor: 'rgba(0,0,0, 0.9)', color: 'white', position: 'absolute', bottom: '0', textAlign: 'center', overflow: 'hidden' }}>
                        <h2 style={{ marginTop: '20px', marginBottom: '20px' }}><FaChevronUp /></h2>
                        <p hidden={showP} style={{ textAlign: 'justify', paddingInline: '30px 30px' }}>Innovated and streamlined digital EDA solutions to accelerate device R&D and boost semiconductor efficiency.</p>
                    </div>
                </div>
                
                <div id='uthoKaAbba' onMouseEnter={pDekhao} onMouseLeave={pMatDekhao}>
                    <img src='/Assets/Portfolio/Scalable-HDL-Simulation-Solutions.png' alt='generativeai' style={{ width: '100%', height: '100%' }} />
                    <div id='Utho' style={{ width: '100%', backgroundColor: 'rgba(0,0,0, 0.9)', color: 'white', position: 'absolute', bottom: '0', textAlign: 'center', overflow: 'hidden' }}>
                        <h2 style={{ marginTop: '20px', marginBottom: '20px' }}><FaChevronUp /></h2>
                        <p hidden={showP} style={{ textAlign: 'justify', paddingInline: '30px 30px' }}>Verilog HDL Simulation Suite enabling fast, scalable, and budget-friendly design verification.</p>
                    </div>
                </div>

            </div>
        </div>


    );
};

export default Portfolio;